


















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Snackbar extends Vue {
    @Prop({ type: String, default: 'is-dark' })
    public type!: string;
    @Prop({ type: String, default: '' })
    public message!: string;
    @Prop({ type: Number, default: 3500 })
    public duration!: number;
    @Prop({ type: String, default: 'is-top', validator(value) { return ['is-top-right', 'is-top', 'is-top-left', 'is-bottom-right', 'is-bottom', 'is-bottom-left' ].indexOf(value) > -1; } })
    public position!: string;
    @Prop({ type: String })
    public container!: string;
    @Prop({ type: String, default: 'OK' })
    public actionText!: string;
    @Prop({ type: Function, default: () => {} })
    public onAction!: () => {};
    @Prop({ type: Boolean, default: false })
    public indefinite!: boolean;
    @Prop({ type: Boolean, default: true })
    public queue!: boolean;

    private isActive: boolean = false;
    private parentTop: HTMLElement | null = null;
    private parentBottom: HTMLElement | null = null;
    private newContainer: string = this.container;
    private newDuration: number = this.duration;
    private timer: NodeJS.Timer | null = null;

    public get correctParent(): HTMLElement | null {
        switch (this.position) {
            case 'is-top-right':
            case 'is-top':
            case 'is-top-left':
                return this.parentTop;

            case 'is-bottom-right':
            case 'is-bottom':
            case 'is-bottom-left':
                return this.parentBottom;
        }

        return null;
    }
    public get transition(): { enter: string, leave: string } {
        switch (this.position) {
            case 'is-top-right':
            case 'is-top':
            case 'is-top-left':
                return { enter: 'fadeInDown', leave: 'fadeOut' };
            case 'is-bottom-right':
            case 'is-bottom':
            case 'is-bottom-left':
                return { enter: 'fadeInUp', leave: 'fadeOut' };

            default:
                return { enter: '', leave: '' };
        }
    }

    public shouldQueue(): boolean {
        const queue = this.queue !== undefined
            ? this.queue
            : true;

        if (!queue) {
            return false;
        }

        return (this.parentTop!.childElementCount > 0 || this.parentBottom!.childElementCount > 0);
    }
    public close(): void {
        if (this.timer != null) {
            clearTimeout(this.timer);
        }

        this.isActive = false;

        // Timeout for the animation complete before destroying
        setTimeout(() => {
            this.$destroy();

            if (typeof this.$el.remove !== undefined) {
                this.$el.remove();
            } else if (this.$el.parentNode != null) {
                this.$el.parentNode.removeChild(this.$el);
            }
        }, 150);
    }
    public showNotice(): void {
        if (this.shouldQueue()) {
            setTimeout(() => this.showNotice(), 250);
            return;
        }

        this.correctParent!.insertAdjacentElement('afterbegin', this.$el);
        this.isActive = true;

        if (!this.indefinite) {
            this.timer = setTimeout(() => this.close(), this.newDuration);
        }
    }
    public setupContainer(): void {
        this.parentTop = document.querySelector<HTMLDivElement>('.notices.is-top');
        this.parentBottom = document.querySelector('.notices.is-top');

        if (this.parentTop != null && this.parentBottom != null) {
            return;
        }

        if (this.parentTop == null) {
            this.parentTop = document.createElement('div');
            this.parentTop.className = 'notices is-top';
        }

        if (this.parentBottom == null) {
            this.parentBottom = document.createElement('div');
            this.parentBottom.className = 'notices is-bottom';
        }

        const container = document.querySelector(this.newContainer) || document.body;

        container.appendChild(this.parentTop);
        container.appendChild(this.parentBottom);

        if (this.newContainer != null) {
            this.parentTop.classList.add('has-custom-container');
            this.parentBottom.classList.add('has-custom-container');
        }
    }
    public action(): void {
        this.onAction();
        this.close();
    }
    public beforeMount(): void {
        this.setupContainer();
    }
    public mounted(): void {
        this.showNotice();
    }
}
